export default __webpack_public_path__ + "static/media/treballadors.252863dd.svg";